import React, { useCallback, useEffect, useState, useMemo } from "react";
import { QrCodeModal } from "../../components/QRCodeModal";
import { useForm } from "react-hook-form";
import { addItem } from "../../core/firebase/functions";
import { db, dbtimestamp } from "../../core/firebase";
import { customToast } from "../../components/Toast";

const getCollection = async (id) => {
  try {
    const querySnapshot = await db.collection('qrcode')
      .where('project.id', '==', id)
      .where('active', '==', true)
      .get();

    return querySnapshot.docs.map(doc => doc.data());
  } catch (error) {
    console.error("Error -> ", error);
    return [];
  }
};

export const getMessageLink = (message, project) => {
  const encapsulatedMessage = `${message} \n\n*${project}*`;
  return encodeURI(`https://wa.me/554831810490?text=${encapsulatedMessage}`);
};

const QRCodeConfigContainer = ({ project = {}, modalIsOpen, handleCloseModal }) => {
  const [isGenerateQRCode, setIsGenerateQRCode] = useState(false);
  const [loading, setLoading] = useState(false);
  const [qrCodeData, setQrCodeData] = useState([]);
  const [shouldRefetch, setShouldRefetch] = useState(false);

  const { register, getValues, reset, handleSubmit, watch } = useForm({ mode: "onChange" });

  const fetchQrCodes = useCallback(async () => {
    if (!project?.value) return;

    setLoading(true);
    try {
      const qrCodes = await getCollection(project.value);
      console.log(qrCodes)
      setQrCodeData(qrCodes);
    } catch (error) {
      console.error("Erro ao buscar QR codes:", error);
    } finally {
      setLoading(false);
    }
  }, [project?.value]);

  useEffect(() => {
    if (modalIsOpen) {
      fetchQrCodes();
    }
  }, [modalIsOpen, fetchQrCodes]);

  useEffect(() => {
    if (shouldRefetch) {
      fetchQrCodes();
      setShouldRefetch(false);
    }
  }, [shouldRefetch, fetchQrCodes]);

  const handleOpenGenerateQrCode = () => setIsGenerateQRCode(true);

  const handleCloseGenerateQrCode = () => {
    setIsGenerateQRCode(false);
    reset();
  };

  const handleCloseAllModals = () => {
    handleCloseModal();
    handleCloseGenerateQrCode();
  };

  const handleSaveQr = useCallback(async () => {
    const { receivedMessage, feedbackMessage, title } = getValues();

    setLoading(true);
    try {
      await addItem(`qrcode`, {
        qrCodeTitle: title,
        receivedMessage,
        feedbackMessage: feedbackMessage || "-",
        project: {
          name: project.name,
          id: project.value,
        },
        qrCodeLink: getMessageLink(receivedMessage, project.value),
        createdAt: dbtimestamp,
      });

      customToast("QR code gerado com sucesso", "success");
      setShouldRefetch(true);
    } catch (error) {
      console.error("Erro ao processar a operação:", error);
      customToast("Erro ao gerar QR code", "error");
    } finally {
      setLoading(false);
      handleCloseGenerateQrCode();
    }
  }, [getValues, project, handleCloseGenerateQrCode]);

  const handleDeleteQrCode = useCallback(async (id) => {
    setLoading(true);
    try {
      const doc = await db
        .collection(`qrcode`)
        .doc(id)
        .get();

      const batch = db.batch();
      batch.update(doc.ref, { active: false })

      await batch.commit();
      customToast("Qr code excluído com sucesso", "success");
      setShouldRefetch(true);
    } catch (error) {
      console.error("Erro ao excluir QrCode:", error);
      customToast("Erro ao excluir Qr code.", "error");
    } finally {
      setLoading(false);
    }
  }, [project?.value]);

  const memoizedQrCodeData = useMemo(() => qrCodeData, [qrCodeData]);

  return (
    <QrCodeModal
      project={project}
      modalIsOpen={modalIsOpen}
      handleCloseModal={handleCloseAllModals}
      handleCloseGenerateQrCode={handleCloseGenerateQrCode}
      handleOpenGenerateQrCode={handleOpenGenerateQrCode}
      isGenerateQrCode={isGenerateQRCode}
      register={register}
      watch={watch}
      handleSubmit={handleSubmit(handleSaveQr)}
      handleDeleteQrCode={handleDeleteQrCode}
      values={getValues()}
      getMessageLink={getMessageLink}
      loading={loading}
      qrCodeData={memoizedQrCodeData}
    />
  );
};

export default QRCodeConfigContainer;